import template from './timepicker.jade';

export class TimepickerController {
  /* @ngInject */
  constructor() {
    this.hourStep = this.hourStep || 1;
    this.minuteStep = this.minuteStep || 15;
  }

  get time() {
    if (this.focus) {
      return this.timeString;
    } else {
      return this.date ? moment(this.date).format('HH:mm') : '';
    }
  }

  set time(timeString) {
    this.timeString = timeString;
    if (!_.isEmpty(timeString)) {
      let time = timeString.match(/(\d+)([:\s](\d+))?\s*(p?)/i);
      this.date = moment(this.date)
        .hours(parseInt(time[1], 10) + ((parseInt(time[1], 10) < 12 && time[4]) ? 12 : 0))
        .minutes(parseInt(time[3], 10) || 0)
        .toDate();
    }
  }

  get hours() {
    return _.isDate(this.date) ? this.date.getHours() : 0;
  }

  set hours(hours) {
    this.date = moment(this.date).hours(parseInt(hours, 10) || 0).toDate();
  }

  get minutes() {
    return _.isDate(this.date) ? this.date.getMinutes() : 0;
  }

  set minutes(minutes) {
    this.date = moment(this.date).minutes(parseInt(minutes, 10) || 0).toDate();
  }

  addMinutes(minutes) {
    this.date = moment(this.date).add(minutes, 'minutes').toDate();
  }

  incrementHours() {
    this.addMinutes(this.hourStep * 60);
  }

  decrementHours() {
    this.addMinutes(this.hourStep * -60);
  }

  incrementMinutes() {
    this.addMinutes(this.minuteStep * 1);
  }

  decrementMinutes() {
    this.addMinutes(this.minuteStep * -1);
  }
}

export function TimepickerComponent() {
  return {
    template,
    controller: TimepickerController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      date: '=ngModel',
      required: '=ngRequired',
      hourStep: '=',
      minuteStep: '=',
      showMeridian: '='
    },
    bindToController: true,
    link: function (scope, element, attrs) {
      let openClass = 'is-open';

      scope.vm.close = (() => {
        element.find('.c-picker').removeClass(openClass);
      });

      element.find('.c-picker__input')
        .click(function (event) {
          element.find('.c-picker').addClass(openClass);
        })
        .focus(function (event) {
          scope.$apply(() => {
            scope.vm.timeString = scope.vm.time;
            scope.vm.focus = true;
          });
          element.find('.c-picker__input').select();
        })
        .blur(function (event) {
          scope.$apply(() => {
            scope.vm.focus = false;
            scope.vm.time = scope.vm.timeString;
          });
        })
        .keyup(function (event) {
          if (event.keyCode == 13) {
            element.find('.c-picker__input').blur();
            scope.vm.close();
          }
        });

      // we need to use mousedown due to angular bug (ignores first click when input has focus)
      element.parents('body').bind('mousedown', (event) => {
        if (!element[0].contains(event.target)) {
          scope.$apply(() => {
            element.find('.c-picker').removeClass(openClass);
          });
        }
      });
    }
  };
};

export default angular.module('app.datetime.timepicker', [])
  .directive('timepicker', TimepickerComponent);



/** WEBPACK FOOTER **
 ** ./src/common/datetime/timepicker.js
 **/